// @flow

import { shouldDisableEmailOverride } from '@tectonics/prs/merchant/config';
import { getMerchant } from '@tectonics/prs/incoming-payment';
import { type IncomingPayment } from './types';

export function shouldHideCustomerEmailField(incomingPayment: IncomingPayment): boolean {
  return shouldDisableEmailOverride(getMerchant(incomingPayment));
}
